module.exports = __webpack_public_path__ + "img/edit-icon1.0e5e9122.png";